import type { AnyRoute } from "@tanstack/react-router";

import { createDeviceTypesRoutes } from "./createDeviceTypesRoutes";
import { createDevicesListRoutes } from "./createDevicesListRoutes";
import type { DevicesRouteDeps } from "./devicesRouteContext";

export type {
  DevicesRouteDeps,
  DevicesRouteFactory,
} from "./devicesRouteContext";

export function createDevicesRoutes(deps: DevicesRouteDeps): AnyRoute[] {
  return [
    ...createDevicesListRoutes(deps),
    ...createDeviceTypesRoutes(deps),
  ];
}
